
function getNidInquiryStatusTextLine(type) {
  switch (type) {
    case 'All':
      return  "احراز هویت نشده";
    
    case 'Accepted':
      return  "احراز هویت شده";
    
    case 'ReadyForInquiry':
      return  "در انتظار احراز هویت";
    
    case 'InProgress':
      return  "در انتظار احراز هویت";
    
    case 'Rejected':
      return  "احراز هویت رد شده";
    
    default:
      return  "";
    
  }
}
export default getNidInquiryStatusTextLine;